import { Checkbox as KCheckbox } from "@progress/kendo-react-inputs";

import type { CheckboxProps as KCheckboxProps } from "@progress/kendo-react-inputs";

interface CheckboxProps extends KCheckboxProps {
  forceLabelPlacement?: boolean;
  testId?: string;
}

export const Checkbox = ({
  className,
  forceLabelPlacement,
  labelPlacement,
  testId,
  name,
  ...otherProps
}: CheckboxProps) => {
  // label placement is preferred after, we want to force it to be consistent
  // across the application unless absolutely certain
  const preferredLabelPlacement = forceLabelPlacement ? labelPlacement : "after";
  return (
    <div className="tc-checkbox" data-testid={`checkbox-wrap-${testId ?? name}`}>
      <KCheckbox
        className={className ?? ""}
        data-testid={testId ?? (name ? `checkbox-${name}` : undefined)}
        name={name}
        labelPlacement={preferredLabelPlacement}
        {...otherProps}
      />
    </div>
  );
};

export default Checkbox;
